import React from "react";
import { CheckCircle2 } from "lucide-react";
import classes from "./Transactions.module.css";

const ledgerTransactions = [
  {
    title: "Customer Payment - Invoice #INV–2024–001",
    date: "Jan 15, 2024",
    amount: "+₦125,000.00",
    code: "REF-001",
    matched: false,
    type: "credit",
  },
  {
    title: "Office Rent Payment - January 2024",
    date: "Jan 14, 2024",
    amount: "-₦75,000.00",
    code: "RENT-JAN24",
    matched: true,
    type: "debit",
  },
  {
    title: "Supplier Payment - ABC Limited",
    date: "Jan 13, 2024",
    amount: "-₦45,000.00",
    code: "SUP-001",
    matched: false,
    type: "debit",
  },
  {
    title: "Service Fee Collection",
    date: "Jan 12, 2024",
    amount: "+₦32,500.00",
    code: "SVC-FEE-001",
    matched: true,
    type: "credit",
  },
];

const bankTransactions = [...ledgerTransactions]; // For demo

const TransactionCard = ({ t }) => {
  return (
    <div className={`${classes.card} ${t.matched ? classes.matchedCard : ""}`}>
      <div className={classes.left}>
        <input type="checkbox" />
        <div>
          <h4>{t.title}</h4>
          <p>{t.date}</p>
        </div>
      </div>
      <div className={classes.right}>
        <div className={classes.amountBlock}>
          {t.matched && (
            <span className={classes.matchBadge}>
              <CheckCircle2 size={16} /> Matched
            </span>
          )}
          <span
            className={t.type === "credit" ? classes.credit : classes.debit}
          >
            {t.amount}
          </span>
        </div>
        <p className={classes.code}>{t.code}</p>
      </div>
    </div>
  );
};

const BankRecon = () => {
  return (
    <div className={classes.wrapper}>
      <div className={classes.reconContainer}>
        <div className={classes.column}>
          <group>
            {" "}
            <div className={classes.header}>
              <h3>Ledger Transactions</h3> <br />
              <p style={{ marginTop: "-28px" }}>
                2/5 matched
              </p>
            </div>
            <input
              className={classes.search}
              placeholder="Search transactions..."
            />
          </group>

          {ledgerTransactions.map((t, idx) => (
            <TransactionCard key={idx} t={t} />
          ))}
        </div>

        <div className={classes.column}>
          <group>
            {" "}
            <div className={classes.header}>
              <h3>Bank Statement</h3> <br />
              <p style={{ marginTop: "-28px" }}>
                2/5 matched
              </p>
            </div>
            <input
              className={classes.search}
              placeholder="Search transactions..."
            />
          </group>

          {bankTransactions.map((t, idx) => (
            <TransactionCard key={idx} t={t} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default BankRecon;
